import Layout from "../Layout"

const Bookmarks = () => {
    return (
        <Layout>
            <div className="bg-white rounded-lg mt-10shadow-md p-4 flex items-center justify-center">
                <div className="text-lg font-semibold">All saved recipes will shown here</div>
            </div>
        </Layout>
    )
}

export default Bookmarks